import Reveal, { Eyebrow } from "./Reveal";

export default function Testimonials({ items }) {
  if (!items?.length) return null;
  return (
    <section className="py-24 sm:py-32 bg-[#1E231F] text-white" data-testid="testimonials-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Eyebrow className="!text-[#A9BF98]">Risultati reali</Eyebrow>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight mt-4">Cosa dicono le mie clienti</h2>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <Reveal key={i} delay={i * 0.1} className={`rounded-3xl border border-white/10 p-7 ${i % 2 ? "md:mt-10" : ""}`}>
              {t.result && <p className="font-display text-3xl text-[#E48A79]" data-testid={`testimonial-result-${i}`}>{t.result}</p>}
              <p className="mt-4 leading-relaxed text-white/80">«{t.text}»</p>
              <p className="mt-6 text-sm font-semibold">{t.name}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
